import {Resolve} from '@angular/router';
import {INDRABookedTripDetails} from '@ibe.models/booked-trip-details.indra.model.lib';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import * as fromStore from '../_store';
import {Store} from '@ngrx/store';
import {filter, take} from 'rxjs/operators';
import * as _ from 'lodash';

@Injectable()
export class ActiveBookedTripIndraResolver implements Resolve<INDRABookedTripDetails> {

	constructor(
		private store: Store<fromStore.State>
	) { }

	resolve(): Observable<INDRABookedTripDetails> {
		this.init();
		return this.store.select(
			fromStore.getSelectedBookedTrip
		).pipe(
			filter(data => !_.isNil(data)),
			take(1)
		);
	}

	private init() {
		this.store.dispatch(new fromStore.LoadingAction());
	}

}
